import { classNames } from '@/shared/lib/classNames';
import cls from './Footer.module.scss';
import { useVisuallyImpairedStore } from '@/entities/VisuallyImpaired';
import UserAgreement from '@/shared/assets/pdf/Пользовательское-соглашение.pdf';
import political from '@/shared/assets/pdf/political-personal-data.pdf';

interface FooterProps {
    className?: string;
}
export const Footer = ({ className }: FooterProps) => {
    const privateClients = [
        { link: 'https://sberbank-insurance.ru/about', text: 'О компании' },
        { link: 'https://sberbank-insurance.ru/about/history', text: 'История' },
        { link: 'https://sberbank-insurance.ru/about/contacts', text: 'Контакты' },
        { link: 'https://sberbank-insurance.ru/news', text: 'Новости' },
        { link: 'https://sberbank-insurance.ru/ESG', text: 'ESG' },
        { link: 'https://sberbank-insurance.ru/direction-request', text: 'Памятка по подаче обращения' },
        { link: 'https://sberbank-insurance.ru/nv', text: 'Налоговый вычет' },
        { link: 'https://sberbank-insurance.ru/fin', text: 'Полезные статьи' },
        { link: 'https://sberbank-insurance.ru/sitemap', text: 'Карта сайта' },
        { link: 'https://sberbank-insurance.ru/policy/ezp', text: 'Электронные заказные письма' },
    ];

    const worldClients = [
        { link: 'https://sberbank-insurance.ru/about/info', text: 'Раскрытие информации' },
        { link: 'https://sberbank-insurance.ru/about/info#financial_metrics', text: 'Финансовые показатели' },
        { link: 'https://sberbank-insurance.ru/about/info#ins_documentation', text: 'Страховая документация' },
        { link: 'https://sberbank-insurance.ru/about/info#policy_actions', text: 'Общие документы' },
        { link: 'https://sberbank-insurance.ru/about/procurement', text: 'Закупки' },
        { link: 'https://sberbank-insurance.ru/safety', text: 'Ваша безопасность' },
        { link: 'https://sberbank-insurance.ru/info.pdf', text: 'Информация о финансовом уполномоченном' },
        { link: 'https://sberbank-insurance.ru/check-policy', text: 'Проверка подписи Страховщика' },
        { link: 'https://sberbank-insurance.ru/reestr_strahovih_agentov', text: 'Реестр страховых агентов' },
    ];

    const privateClintsList = privateClients.map((el) => (
        <li key={el.text}>
            <a href={el.link}>{el.text}</a>
        </li>
    ));

    const worldClientsList = worldClients.map((el) => (
        <li key={el.text}>
            <a href={el.link}>{el.text}</a>
        </li>
    ));

    const { setVI } = useVisuallyImpairedStore();

    const loadScripts = async () => {
        const btn = document.getElementById('specialButton');
        btn?.click();
        setVI(true);
    };

    return (
        <footer className={classNames(cls.Footer, {}, [className])}>
            <div className={cls.wrapper}>
                <div className={cls.gridWrap}>
                    <div className={`${cls.col} ${cls.One}`}>
                        <div className={cls.el}>
                            <p className={cls.fotTitle}>Для частных клиентов:</p>
                            <a href="tel:900" className={cls.fotTel}>
                                900
                            </a>
                            <p>
                                Бесплатно&nbsp;с&nbsp;мобильных&nbsp;устройств
                                <br />
                                на&nbsp;территории&nbsp;РФ
                            </p>
                        </div>
                        <div className={`${cls.el} ${cls.elMob}`}>
                            <p className={cls.fotTitle}>Для звонков по всему миру:</p>
                            <a href="tel:84955005550" className={cls.fotTel}>
                                +8 495 500-55-50
                            </a>
                            <p>
                                Стоимость&nbsp;звонка&nbsp;зависит&nbsp;от&nbsp;тарифа
                                <br />
                                вашего&nbsp;мобильного&nbsp;оператора
                            </p>
                        </div>
                        <ul className={`${cls.list}`}>{privateClintsList}</ul>
                    </div>
                    <div className={`${cls.col} ${cls.Two}`}>
                        <div className={cls.flexWrap}>
                            <div className={`${cls.el} ${cls.elDeks}`}>
                                <p className={cls.fotTitle}>Для звонков по всему миру:</p>
                                <a href="tel:84955005550" className={cls.fotTel}>
                                    +8&nbsp;495&nbsp;500-55-50
                                </a>
                                <p>
                                    Стоимость&nbsp;звонка&nbsp;зависит&nbsp;от&nbsp;тарифа
                                    <br />
                                    вашего&nbsp;мобильного&nbsp;оператора
                                </p>
                            </div>
                            <ul className={`${cls.list} `}>{worldClientsList}</ul>
                        </div>
                    </div>
                    <div className={`${cls.col} ${cls.colDeks} ${cls.Three}`}>
                        <div className={`${cls.el}`}>
                            <p className={cls.fotTitle}>
                                График работы <br />
                                клиентской зоны:
                            </p>
                            <div>
                                <p>пн.– пт. с 08:00 до 20:00,</p>
                                <p>сб.–вс. — выходной</p>
                            </div>
                            <p>
                                121170, г.Москва, ул.Поклонная, д. 3, <br />
                                корп. 1, 1 этаж
                            </p>
                        </div>
                    </div>
                    <button onClick={loadScripts} type="button" className={cls.invalid}>
                        Версия для слабовидящих
                    </button>
                </div>
            </div>
            <div className={cls.bottom}>
                <div className={cls.wrapper}>
                    <div className={cls.footerInfo}>
                        <div className={`${cls.flexWrap} ${cls.elMy}`}>
                            <div className={cls.notions}>
                                <p className={cls.bottomText}>ООО СК «Сбербанк страхование жизни»</p>
                                <p className={cls.bottomText}>
                                    Лицензия на осуществление страхования СЖ&nbsp;№&nbsp;3692 (вид деятельности – добровольное
                                    страхование жизни), Лицензия на осуществление страхования СЛ&nbsp;№&nbsp;3692&nbsp;(вид
                                    деятельности - добровольное личное страхование, за исключением добровольного страхования
                                    жизни) выданы Банком России без ограничения срока действия.
                                </p>
                                <p className={cls.bottomText}>
                                    Все споры, возникающие между сторонами в процессе исполнения договора страхования, разрешаются
                                    в досудебном претензионном порядке: путем переговоров, обмена письмами, уточнения условий
                                    договора страхования, а так же, при взаимном согласии сторон, внесением дополнений и изменений
                                    в договор страхования.
                                </p>
                            </div>
                        </div>
                        <div className={cls.agreements}>
                            <p>Соглашение по электронному документообороту</p>
                            <a href={UserAgreement} target="_blank" rel="noreferrer">
                                Пользовательское соглашение
                            </a>
                            <a href={political} target="_blank" rel="noreferrer">
                                Политика в отношении обработки персональных данных
                            </a>
                        </div>
                        <div className={cls.el}>
                            <p>
                                Информация соответствует информации направленной 08.10.2020 в Банк России для размещения на
                                официальном сайте Банка России.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
